import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { Market } from 'clickNgo/configs/geo'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { I515Form } from 'clickNgo/models/crud/forms/i515Form'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapProfilingCodeFrom515Form } from './mapping/mapProfilingCodeFrom515Form'

interface IFetchProfilingCodes {
  type: ProfilingCodeType
  country?: string
  market?: Market
}

const DEFAULT_PAGE_SIZE = 10000
const DEFAULT_PAGE = 0

export const fetchProfilingCodesByTypeAndMarket = (
  { type, market, country }: IFetchProfilingCodes,
  options?: ICrudFetchOptions
) => {
  const source = CrudStore.get<I515Form>(CrudStoreItem.CodesDictionary, options?.cacheKey)

  const filterByType = {
    logic: Logic.OR,
    filters: [
      {
        operator: Operator.EQUAL,
        field: 'Type',
        value: type + 's',
      },
      {
        operator: Operator.EQUAL,
        field: 'Type',
        value: type,
      },
    ],
  }

  const filters: IDataProviderFilter[] = [filterByType]

  if (market) {
    filters.push({
      logic: Logic.OR,
      filters: [
        { operator: Operator.EQUAL, field: 'GeoMarket', value: '' },
        { operator: Operator.ISNULL, field: 'GeoMarket', value: '' },
        {
          operator: Operator.CONTAINS,
          field: 'GeoMarket',
          value: market,
        },
      ],
    })
  }

  if (country) {
    filters.push({
      logic: Logic.OR,
      filters: [
        { operator: Operator.EQUAL, field: 'Countries', value: '' },
        { operator: Operator.ISNULL, field: 'Countries', value: '' },
        {
          operator: Operator.CONTAINS,
          field: 'Countries',
          value: country,
        },
      ],
    })
  }

  const filter: IDataProviderFilter = {
    logic: Logic.AND,
    filters,
  }

  source.setFilter(filter)
  source.setPaging(
    options?.paging || {
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
    }
  )

  return source
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result) => {
      if (result && result.items) {
        return result.items.map(mapProfilingCodeFrom515Form)
      }

      return []
    })
    .catch((err) => {
      Logger.error(err)
      return []
    })
}
